"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = _interopRequireDefault(require("lodash"));

var _classnames = _interopRequireDefault(require("classnames"));

var _markdown = _interopRequireDefault(require("../components/markdown"));

var _util = require("../components/contentful-views/util");

var _sections = require("../components/contentful-views/sections");

var _commonPropTypes = require("../components/common-prop-types");

var _list = _interopRequireDefault(require("../components/list"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * ListWidget mapping for Contentful List content types.
 * https://app.contentful.com/spaces/ljtyf78xujn2/content_types/list/fields
 */
var ListWidget = function ListWidget(_ref) {
  var customWidgets = _ref.customWidgets,
      stringSubstitutions = _ref.stringSubstitutions,
      model = _ref.model,
      id = _ref.id;
  var className = id; // legacy, id was being passed as class name.

  var displayOption = _lodash["default"].get(model, 'fields.displayOption');

  var listItems = _lodash["default"].get(model, 'fields.listItems');

  var text = _lodash["default"].get(model, 'fields.text');

  var title = _lodash["default"].get(model, 'fields.title');

  var titleText = (0, _util.stringSubstitution)(title, stringSubstitutions);
  var subTitle = text ? /*#__PURE__*/_react["default"].createElement(_markdown["default"], {
    className: "subTitle paragraph",
    source: (0, _util.stringSubstitution)(text, stringSubstitutions)
  }) : null;
  var children = (0, _sections.getSectionsArray)(listItems, customWidgets);
  return /*#__PURE__*/_react["default"].createElement(_list["default"], {
    className: (0, _classnames["default"])(className, _lodash["default"].camelCase(displayOption)),
    displayOption: displayOption,
    subTitle: subTitle,
    title: titleText
  }, children);
};

ListWidget.propTypes = {
  customWidgets: _commonPropTypes.customWidgetsPropType,
  stringSubstitutions: _commonPropTypes.stringSubstitutionsPropType,
  id: _propTypes["default"].string,
  model: _propTypes["default"].shape({})
};
ListWidget.defaultProps = {
  customWidgets: {},
  stringSubstitutions: {},
  id: null,
  model: {}
};
(0, _sections.registerWidget)('list', ListWidget);
var _default = ListWidget;
exports["default"] = _default;